/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Battery_Changed_OnInputs */



/**
* | output |
* | --- |
* | "Battery changed on {date}" |
*
* @param {Battery_Changed_OnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const battery_changed_on = /** @type {((inputs: Battery_Changed_OnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Battery_Changed_OnInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Battery changed on ${i?.date}`)
	return /** @type {LocalizedString} */ (`Pile changée le ${i?.date}`)
});